module.exports = _.partial;


//////////////////
// WEBPACK FOOTER
// external "_.partial"
// module id = 516
// module chunks = business-manager/video-library-page full-screen-modals/full-screen-modals mobile-overlay/mobile-overlay mobile/mobile widget/widget dashboard/dashboard app-settings/app-settings